module.exports = __webpack_public_path__ + "img/42.9.TU.5e28668b.png";